document.addEventListener("DOMContentLoaded", function () {
    attachPurchaseOptionListener();
    observeCartDrawer();
    observeCartChanges();  
   
    

    async function updateCartWithSubscription(selectedName) {
        try {
            showLoader();
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();

            let cartItems = [];
            cartData.items.forEach(item => {
                const sellingPlan = getItemSellingPlan(item.id, selectedName);
                cartItems.push({
                    id: item.id,
                    quantity: item.quantity,
                    selling_plan: sellingPlan
                });
            });

            if (cartItems.length === 0) {
                alert("No matching subscription plan found for selected option.");
                hideLoader();
                return;
            }

            await fetch("/cart/clear.js", { method: "POST" });

            await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: cartItems })
            });

            await updateCartDrawer();

                 
            location.reload();

           

        } catch (error) {
            console.error("Error updating cart:", error);
        } finally {
            hideLoader();
        }
    }

    async function updateCartDrawer() {
        try {
            const timestamp = new Date().getTime();
            let response = await fetch(`${window.Shopify.routes.root}?section_id=main-cart-items&_=${timestamp}`);
            let html = await response.text();

            const newCartHTML = new DOMParser().parseFromString(html, "text/html");
            const cartDrawer = document.querySelector(".cart__items");
            const newCartDrawer = newCartHTML.querySelector(".cart__items");

            if (cartDrawer && newCartDrawer) {
                cartDrawer.innerHTML = ""; 
                cartDrawer.innerHTML = newCartDrawer.innerHTML;
               
            } else {
                console.warn("Cart item elements not found.");
            }
        } catch (error) {
            console.error("Error updating cart items:", error);
        }
    }

    function attachPurchaseOptionListener() {
        const purchaseSelect = document.querySelector(".cart-purchase-option select");
        if (purchaseSelect) {
            purchaseSelect.removeEventListener("change", handlePurchaseOptionChange);
            purchaseSelect.addEventListener("change", handlePurchaseOptionChange);
        }
    }

    function handlePurchaseOptionChange() {
        showLoader(); 
        const selectedName = this.options[this.selectedIndex].getAttribute("data-name").trim().toLowerCase();
        updateCartWithSubscription(selectedName);
    }

    function observeCartDrawer() {
        const cartDrawer = document.querySelector(".cart__items");
        if (cartDrawer) {
            const observer = new MutationObserver(() => {
                attachPurchaseOptionListener();
            });

            observer.observe(cartDrawer, { childList: true, subtree: true });
        } else {
            console.warn("Cart drawer not found. Observer not started.");
        }
    }

    function showLoader() {
        const cartDrawer = document.querySelector('.cart__items');
        let loader = document.querySelector('.cart-loader');
        if (!loader && cartDrawer) {
            const loaderDiv = document.createElement("div");
            loaderDiv.className = "cart-loader";
            loaderDiv.innerHTML = `<div class="loading-spinner"></div>`;
            cartDrawer.appendChild(loaderDiv);
        }
    }

    function hideLoader() {
        let loader = document.querySelector('.cart-loader');
        if (loader) {
            loader.remove();
        }
    }

    function getItemSellingPlan(id, name) {
        const sellingPlanSelector = document.querySelector(`.selling-plan-option[data-id="${id}"] option[data-name="${name}"]`);
        return sellingPlanSelector ? sellingPlanSelector.value : null;
    }

    // New function to handle cart quantity change and item removal
    function observeCartChanges() {
        const cartItems = document.querySelectorAll(".cart__item");

        cartItems.forEach(item => {
            const quantityInput = item.querySelector("input.quantity");
            const removeButton = item.querySelector(".cart-remove");

            if (quantityInput) {
                quantityInput.addEventListener("change", async function () {
                    showLoader();
                    await updateCartDrawer(); // Refresh cart after quantity change     
                });
            }

            if (removeButton) {
                removeButton.addEventListener("click", async function () {
                    showLoader();
                    await updateCartDrawer(); // Refresh cart after item removal
                    
                });
            }
        });
    }
});


